import { SvgIcon, SvgIconProps } from '@mui/material';

// Settings gear. Strokes with `currentColor` so it inherits the consumer's color
// (e.g. a palette token via `color`/sx).
export const SettingsIcon = ({ sx, ...rest }: SvgIconProps) => (
  <SvgIcon
    sx={[{ fill: 'none', stroke: 'currentColor' }, ...(Array.isArray(sx) ? sx : [sx])]}
    viewBox="0 0 20 20"
    {...rest}
  >
    <path
      d="M8.65039 3.81117C8.99388 2.39628 11.0061 2.39628 11.3496 3.81117C11.5715 4.72517 12.6187 5.15891 13.4219 4.66952C14.6652 3.91193 16.0881 5.33479 15.3305 6.57815C14.8411 7.38134 15.2748 8.4285 16.1888 8.65039C17.6037 8.99388 17.6037 11.0061 16.1888 11.3496C15.2748 11.5715 14.8411 12.6187 15.3305 13.4219C16.0881 14.6652 14.6652 16.0881 13.4219 15.3305C12.6187 14.8411 11.5715 15.2748 11.3496 16.1888C11.0061 17.6037 8.99388 17.6037 8.65039 16.1888C8.4285 15.2748 7.38135 14.8411 6.57815 15.3305C5.33479 16.0881 3.91193 14.6652 4.66952 13.4219C5.15891 12.6187 4.72517 11.5715 3.81117 11.3496C2.39628 11.0061 2.39628 8.99388 3.81117 8.65039C4.72517 8.4285 5.15891 7.38134 4.66952 6.57815C3.91193 5.33479 5.33479 3.91192 6.57815 4.66952C7.38135 5.15891 8.4285 4.72517 8.65039 3.81117Z"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="10" cy="10" r="2.5" strokeWidth="1.25" />
  </SvgIcon>
);
